import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventSummary } from '../../data-access/models/eventSummary.model';
import { ButtonAction } from '../../enums/buttonAction';
import { Router } from '@angular/router';
import { DataService } from '../../data-access/services/data.service';
import { status } from "../../enums/statusEnum";
import { Roles, UserAttributes } from '../../../authentication/data-access/models/auth.model';
import { UserStore } from '../../data-access/stores/user.store';
import { EventPhoto } from "../../../student/models/photo.model";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { FileContents } from "../../data-access/models/file-contents.model";
import { dataUrl } from "../../enums/dataURIs";
import { eventFileTraverser } from "../../utils/functions/traverseDownloadedFiles.function";
import {DocumentStatus} from "../../enums/documentStatus";
import { MatDialog } from '@angular/material/dialog';
import { RsvpDialogComponent } from '../rsvp-dialog/rsvp-dialog.component';
import { EventsService } from '../../data-access/services/events.service';
import { SnackBarDuration } from '../../enums/snackBarDuration';
import { Store } from '@ngrx/store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { reloadComponent } from '../../utils/functions/reloadComponent';
import { SnackBarMessage } from '../../enums/snackBarMessage';
import { EventsTitles, EventStatus } from "../../../admin/enums/eventsMessages";
import { ImagePaths } from "../../../admin/enums/imagePaths";

@Component({
    selector: 'app-event-summary',
    templateUrl: './event-summary.component.html',
    styleUrl: './event-summary.component.scss',
    standalone: false
})
export class EventSummaryComponent implements OnInit{
  @Input() event!: EventSummary;
  @Input() year!: number;
  @Output() refresh = new EventEmitter<boolean>();
  role!: string;
  isOverviewer: boolean = false;
  isStudent: boolean = false;
  userRoles!: Roles;
  rolesEnum = Roles;
  eventPhoto!: EventPhoto;
  eventPhotoUrl!: SafeUrl | string;
  blobResult!: FileContents;
  buttonAction: typeof ButtonAction = ButtonAction;
  protected readonly Roles = Roles;
  protected readonly status = status;
  protected readonly eventStatus = EventStatus;
  dietaryRequirements: string[] = [];
  user:UserAttributes = {} as UserAttributes;

  constructor(
    private router: Router,
    private userStore: UserStore,
    private shareDataService: DataService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private eventService: EventsService,
    private snackBar: MatSnackBar
  ) {
    this.isOverviewer = this.userStore.hasRole([this.rolesEnum.OVERVIEWER]);
    this.isStudent = this.userStore.hasRole([this.rolesEnum.STUDENT])
    this.userStore.get().subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.eventPhoto = this.event.downloadedEventImage as EventPhoto ||
    { eventImage:{ base64: this.event.eventImage, fileExtention:'.png'} as FileContents } as EventPhoto;
    this.viewImage(this.event.eventImage);
  }

  navigateToEventDetailsPage(eventId: string | number) {
    this.shareDataService.setFromDetails(true);
    if (this.isOverviewer) {
      this.router.navigate([`/admin/events/${eventId}`]);
    } else {
      this.router.navigate([`/student/events/${eventId}`]);
    }
  }

  loadEventImage(): void {
    const { jpeg, png, jpg } = dataUrl;
    const filteredDataUrl = { jpg, png, jpeg };
    if (this.blobResult && this.blobResult.base64 && this.blobResult.fileExtention) {
      this.eventPhotoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        filteredDataUrl[this.blobResult.fileExtention as keyof typeof filteredDataUrl] + this.blobResult.base64
      ) as SafeUrl;
    }
    this.cdr.detectChanges();
  }

  viewImage(eventImage: string) {
    if (this.event.eventImage !== EventsTitles.NOT_AVAILABLE) {
      this.blobResult = eventFileTraverser(this.eventPhoto, eventImage);
      this.loadEventImage();
    } else {
      this.eventPhotoUrl = ImagePaths.DEFAULT_EVENT_IMAGE;
    }
  }

  showRsvpButton(event: EventSummary): boolean {
    return this.userStore.hasRole([this.rolesEnum.STUDENT]) && event.rsvp === DocumentStatus.PENDING;
  }

  openRsvpDialog(event: any) {
  const dialogRef = this.dialog.open(RsvpDialogComponent, {
    data: event ,
    width: '30rem',
    disableClose: false
  });
  dialogRef.afterClosed().subscribe((result) => {
    Object.assign(result, { eventDetails: this.event });
    this.eventService.rsvpForEvent(result).subscribe((response) => {
      if (!response.errors) {
        this.snackBar.open(
          SnackBarMessage.RSVP_SUCCESS
          ,
          SnackBarMessage.CLOSE,
          {
            duration: SnackBarDuration.DURATION,
            panelClass: ['success-snackbar'],
          },
        )
      }else {
        this.snackBar.open(
          SnackBarMessage.RSVP_FAILURE,
          SnackBarMessage.CLOSE,
          {
            duration: SnackBarDuration.DURATION,
            panelClass: ['error-snackbar'],
          },
        )
      }
    })
    reloadComponent(true, this.router);
  })
}
}
